import { find, register } from '../../../../Javascript/Sysmex/Utils'

const Slider = el => {
  const input = find('[data-input]', el)
  const tooltip = find('[data-tooltip]', el)
  input.addEventListener('change', updateTooltipPosition.bind(this, input, tooltip))
  input.addEventListener('input', updateTooltipPosition.bind(this, input, tooltip))
  setTimeout(updateTooltipPosition.bind(this, input, tooltip), 300)
}

const updateTooltipPosition = (input, tooltip) => {
  const data = tooltip.dataset
  const value = input.value
  const length = data.max - data.min
  const percentage = (value - data.min) / length
  // TODO: calc real width and offsets
  const width = input.offsetWidth - 21
  const left = percentage * width - (tooltip.offsetWidth / 2) + 14

  tooltip.style.left = `${left}px`
  tooltip.innerText = `${value}${data.unit ? ' ' + data.unit : ''}`
}

register('Slider', Slider)
